module.exports = __webpack_public_path__ + "static/media/71.1fb56cb4.gif";